import { InjectionKey } from "vue";
import { CFormProps } from "./type";

export interface FormItemContext {
  prop?: string;
  validate: () => string;
}

export const FormInjectionKey: InjectionKey<{
  labelWidth: CFormProps["labelWidth"];
  children: FormItemContext[];
  rules: CFormProps["rules"];
  model: CFormProps["model"];
  readonly: CFormProps["readonly"];
}> = Symbol("FormProvide");

export const FormItemInjectionKey: InjectionKey<{
  checkPorp: (error?: boolean) => void;
}> = Symbol("FormItemProvide");
